const dev = {
  ontimeApi: "https://localhost:5001",
  ontimeSignalRServer: "https://localhost:5001",
  ontimeIdentity: "https://localhost:5001",
  ridersTemplateBaseUrl: "https://www.ontime.bike/templates",
  docsBaseUrl: "https://www.ontime.bike/docs",
  appInsightsConnectionString: ""
};
const prod = {
  ontimeApi: "https://api.ontime.bike",
  ontimeSignalRServer: "https://apps-ontimev2-api.azurewebsites.net",
  ontimeIdentity: "https://id.ontime.bike",
  ridersTemplateBaseUrl: "https://www.ontime.bike/templates",
  docsBaseUrl: "/docs",
  appInsightsConnectionString: "InstrumentationKey=db1796b1-200d-4db7-b170-34a706954192;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=43bb2e6e-f4d8-4e1e-a035-eae0c72dc6fe"
};

const stageSettings = process.env.REACT_APP_STAGE === "dev" ? dev : prod;

const config = {
  managementGroups: {
    organizer: "organizer",
    advancedOrganizer: "organizerplus",
    administrator: "ontimeadmin",
  },
  ...stageSettings,
};

export default config;
